<template>
<!-- 16×16 geometry (IconBase default viewBox). Path was previously 24-box coords. -->
<path d="M5.5 3.2v9.6c0 .56.61.91 1.09.62l8.3-4.8a.7.7 0 0 0 0-1.24l-8.3-4.8A.7.7 0 0 0 5.5 3.2Z" fill="currentColor"/>
</template>
